import { useRouter } from 'next/router';
import { useCallback } from 'react';
import { Image } from '@components/common/Image';
import { SimpleImage } from '@components/common/SimpleImage';
import { UiKitButton } from '@components/common/ui-kit-button';
import { Container } from '@features/Unsubscribe/components/Container';
import { Title } from '@features/Unsubscribe/components/Title';
import { useUnsubscribeAnalytics } from '@features/Unsubscribe/hooks/use-unsubscribe-analytics';
import type { TpWizardSteps } from '@features/Unsubscribe/types';
import { closeWebView } from '@features/Unsubscribe/utils/close-web-view';
import styles from './LifetimeActivated.module.scss';
export const LifetimeActivated = (_props: TpWizardSteps) => {
  const {
    query
  } = useRouter();
  const {
    origin
  } = query;
  const {
    defaultEventOptions,
    trackUnsubscribeEvent
  } = useUnsubscribeAnalytics();
  const handleDone = useCallback(() => {
    trackUnsubscribeEvent('cancel_lifetime_activated_done_tapped');
    if (origin === 'app') {
      closeWebView();
    } else {
      window.close();
    }
  }, [origin, trackUnsubscribeEvent]);
  return <Container className={styles.container} eventOnMounted="cancel_lifetime_activated_opened" eventOptions={defaultEventOptions} data-sentry-element="Container" data-sentry-component="LifetimeActivated" data-sentry-source-file="index.tsx">
      <div className={styles.imageWrapper}>
        <Image src="lifetime-activated.webp" alt="gift-premium" layout="fill"
      // width={375}
      // height={190}
      data-sentry-element="Image" data-sentry-source-file="index.tsx" />
      </div>

      <div className={styles.card}>
        <SimpleImage className={styles.icon} src="switch.svg" width="37" height="21" alt="discount" data-sentry-element="SimpleImage" data-sentry-source-file="index.tsx" />
        <span>Forever access</span>
      </div>

      <Title className={styles.title} data-sentry-element="Title" data-sentry-source-file="index.tsx">Lifetime access is activated</Title>
      <p className={styles.subtitle}>
        Congrats! You have a lifetime Premium access now: you won&apos;t be
        charged anymore
      </p>

      <UiKitButton fullWidth onClick={handleDone} className={styles.button} data-sentry-element="UiKitButton" data-sentry-source-file="index.tsx">
        Done
      </UiKitButton>
    </Container>;
};